import { Box, Stack, Text } from '@mantine/core';

import { NavLink } from 'react-router-dom';

const IdCell = ({ cell }) => {
    const { column, row } = cell;
    const rowData = row.original;
    return (
        <Box
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '16px',
            }}>
            <NavLink to={`/campaigns/scripts/${rowData.id}`}>
                <Text ta={'center'}>{rowData.id}</Text>
            </NavLink>
        </Box>
    );
};

const IdColumn = () => ({
    accessorKey: 'id',
    header: 'Id',
    size: 1,
    Cell: ({ cell }) => <IdCell cell={cell} />,
});
export default IdColumn;
